import { AbstractFile } from "../nextcloud/classes";

export class EMailAttachement extends AbstractFile {
    public blob: Blob;
    public name: string;
    public size: number;
    public id: string;
}

export class EMailAddress {
    address: string;
    guid: string;
    name: string;
}

export class EMailAudit {
    body: string;
    guid: string;
    received: string;
    receivedUtc: string;
    htmlBody: string;
    incoming: boolean;
    issueAuditWrapperId: string;
    messageId: string;
    receiver: EMailAddress;
    receiverId: string;
    subject: string;
    transmitter: EMailAddress;
    transmitterId: string;
    inbox: number;
    mailAttachements: EMailAttachement[];
}

export const EMailInbox = {
    Incident: 0,
    Assignment: 1
}